export const ORDERING_KEYS = {
    EQUIPMENT: "equipment",
    CATEGORY: "category",
    USER: "user",
}
